/* eslint-disable prettier/prettier */
(() => {
  const sass = getComputedStyle(document.documentElement).getPropertyValue('--grid-lg');
  const width = parseInt(sass.slice(0, sass.length - 2), 10);
  const mobile = width || 842;

  const image = document.querySelector('.site-content .hero-content');
  
  if (!image) return;

  const positions = {
    desktop: 'desktop',
    mobile: 'mobile'
  }

  const state = {
    currentPosition: positions.desktop, // desktop or mobile
  }

  const dom = {
    source: {
      container: document.querySelector('.site-content .hero-content').parentNode
    },
    dest: {
      container: null
    }
  };

  if (!dom.source.container) return;

  const initContainer = () => { // init container
    dom.dest.container = document.createElement('div');
    dom.dest.container.classList.add('mobile-hero-container');
    document.body.insertBefore(dom.dest.container, document.querySelector('main'));
  };
  initContainer();

  const handleResize = () => {
    if (window.innerWidth > mobile) {
      // desktop
      if (state.currentPosition === positions.desktop) return;
      dom.source.container.appendChild(image);
      state.currentPosition = positions.desktop;
    } else {
      // mobile
      if (state.currentPosition === positions.mobile) return;
      dom.dest.container.appendChild(image);
      state.currentPosition = positions.mobile;
    }
  }

  handleResize();

  let timeout = null;

  window.addEventListener('resize', () => {
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(handleResize, 30);
  });

})();
